// Constants cho tính năng AI Price
export const PROPERTY_TYPES = {
  APARTMENT: "apartment",
  LOW_RISE_PROJECT: "low_rise_project",
  LAND_PROJECT: "land_project",
  PRIVATE_HOUSE: "private_house",
  OTHER_PROPERTY: "other_property",
};

export const PROPERTY_TYPE_LABELS = {
  [PROPERTY_TYPES.APARTMENT]: "Căn hộ",
  [PROPERTY_TYPES.LOW_RISE_PROJECT]: "Thấp tầng dự án",
  [PROPERTY_TYPES.LAND_PROJECT]: "Đất nền dự án",
  [PROPERTY_TYPES.PRIVATE_HOUSE]: "Nhà thổ cư",
  [PROPERTY_TYPES.OTHER_PROPERTY]: "BĐS khác",
};

// Options cho số phòng ngủ - dùng chung cho tất cả loại BĐS
export const BEDROOM_OPTIONS = [
  "1",
  "1PN +1",
  "2",
  "2PN+1",
  "3",
  "3PN+1",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  ">10",
];

// Dropdown options cho từng loại BDS
export const APARTMENT_OPTIONS = {
  types: [
    "Căn hộ chung cư",
    "Căn hộ penthouse",
    "Căn hộ duplex",
    "Căn hộ studio",
    "Office Tel",
    "Shophouse Chân đế",
    "Condotel",
    "Căn hộ chung cư mini",
  ],
  legalStatus: [
    "Sổ hồng/Sổ đỏ",
    "Sổ đỏ 50 năm",
    "Hợp đồng mua bán",
    "Chưa có số",
    "Chưa có hợp đồng mua bán",
    "Giấy tờ khác",
  ],
  furnitureStatus: [
    "Nội thất đầy đủ",
    "Nội thất cơ bản liền tường",
    "Không có nội thất",
  ],
  saleGoal: [
    "Bán nhanh/gấp",
    "Không vội (muốn bán giá cao nhất)",
    "Chỉ tham khảo thị trường",
  ],
  balconyDirection: [
    "Đông",
    "Tây",
    "Nam",
    "Bắc",
    "Đông Nam",
    "Đông Bắc",
    "Tây Nam",
    "Tây Bắc",
  ],
};

export const LOW_RISE_PROJECT_OPTIONS = {
  types: [
    "Liên kế",
    "Biệt thự đơn lập",
    "Biệt thự song lập",
    "Biệt thự Tứ lập",
    "Shophouse",
  ],
  legalStatus: [
    "Sổ hồng/Sổ đỏ",
    "Sổ đỏ 50 năm",
    "Hợp đồng mua bán",
    "Chưa có số",
    "Chưa có hợp đồng mua bán",
    "Giấy tờ khác",
  ],
  furnitureStatus: [
    "Nội thất đầy đủ",
    "Nội thất cơ bản liền tường",
    "Không có nội thất",
  ],
  saleGoal: [
    "Bán nhanh/gấp",
    "Không vội (muốn bán giá cao nhất)",
    "Chỉ tham khảo thị trường",
  ],
  doorDirection: [
    "Đông",
    "Tây",
    "Nam",
    "Bắc",
    "Đông Nam",
    "Đông Bắc",
    "Tây Nam",
    "Tây Bắc",
  ],
};

export const LAND_PROJECT_OPTIONS = {
  types: [
    "Đất nhà liền kề",
    "Đất biệt thự đơn lập",
    "Đất biệt thự song lập",
    "Đất biệt thự Tứ lập",
    "Đất shophouse",
  ],
  legalStatus: [
    "Sổ hồng/Sổ đỏ",
    "Sổ đỏ 50 năm",
    "Hợp đồng mua bán",
    "Chưa có số",
    "Chưa có hợp đồng mua bán",
    "Giấy tờ khác",
  ],
  saleGoal: [
    "Bán nhanh/gấp",
    "Không vội (muốn bán giá cao nhất)",
    "Chỉ tham khảo thị trường",
  ],
  landDirection: [
    "Đông",
    "Tây",
    "Nam",
    "Bắc",
    "Đông Nam",
    "Đông Bắc",
    "Tây Nam",
    "Tây Bắc",
  ],
};

export const PRIVATE_HOUSE_OPTIONS = {
  types: ["Nhà riêng", "Nhà mặt phố"],
  legalStatus: [
    "Sổ hồng/Sổ đỏ",
    "Sổ đỏ 50 năm",
    "Hợp đồng mua bán",
    "Chưa có số",
    "Chưa có hợp đồng mua bán",
    "Giấy tờ khác",
  ],
  furnitureStatus: [
    "Nội thất đầy đủ",
    "Nội thất cơ bản liền tường",
    "Không có nội thất",
  ],
  saleGoal: [
    "Bán nhanh/gấp",
    "Không vội (muốn bán giá cao nhất)",
    "Chỉ tham khảo thị trường",
  ],
  doorDirection: [
    "Đông",
    "Tây",
    "Nam",
    "Bắc",
    "Đông Nam",
    "Đông Bắc",
    "Tây Nam",
    "Tây Bắc",
  ],
};

export const OTHER_PROPERTY_OPTIONS = {
  types: ["Lô đất", "Kho, xưởng", "Trang trại, khu nghỉ dưỡng"],
  legalStatus: [
    "Sổ hồng/Sổ đỏ",
    "Sổ đỏ 50 năm",
    "Hợp đồng mua bán",
    "Chưa có sổ",
    "Chưa có hợp đồng mua bán",
    "Giấy tờ khác",
  ],
  furnitureStatus: [
    "Nội thất đầy đủ",
    "Nội thất cơ bản liền tường",
    "Không có nội thất",
  ],
  saleGoal: [
    "Bán nhanh/gấp",
    "Không vội (muốn bán giá cao nhất)",
    "Chỉ tham khảo thị trường",
  ],
  direction: [
    "Đông",
    "Tây",
    "Nam",
    "Bắc",
    "Đông Nam",
    "Đông Bắc",
    "Tây Nam",
    "Tây Bắc",
  ],
};

// Cấu hình form fields cho từng loại BDS
export const PROPERTY_FORM_CONFIG = {
  [PROPERTY_TYPES.APARTMENT]: {
    dropdownFields: [
      {
        key: "apartmentType",
        label: "Loại căn hộ",
        options: APARTMENT_OPTIONS.types,
        required: true,
      },
      {
        key: "legalStatus",
        label: "Tình trạng pháp lý",
        options: APARTMENT_OPTIONS.legalStatus,
        required: true,
      },
      {
        key: "furnitureStatus",
        label: "Tình trạng nội thất",
        options: APARTMENT_OPTIONS.furnitureStatus,
        required: true,
      },
      {
        key: "saleGoal",
        label: "Mục tiêu check giá bán",
        options: APARTMENT_OPTIONS.saleGoal,
        required: true,
      },
      {
        key: "balconyDirection",
        label: "Hướng ban công",
        options: APARTMENT_OPTIONS.balconyDirection,
        required: true,
      },
      {
        key: "bedrooms",
        label: "Số phòng ngủ",
        options: BEDROOM_OPTIONS,
        required: true,
      },
    ],
    inputFields: [
      { key: "projectName", label: "Tên dự án", type: "text", required: true },
      { key: "address", label: "Địa chỉ", type: "text", required: true },
      { key: "building", label: "Toà/Khu", type: "text", required: false },
      { key: "floor", label: "Tầng/Dãy", type: "text", required: false },
      {
        key: "apartmentCode",
        label: "Mã căn hộ",
        type: "text",
        required: false,
      },
      { key: "bathrooms", label: "Số WC", type: "number", required: true },
      { key: "area", label: "Diện tích (m2)", type: "number", required: true },
      {
        key: "constructionYear",
        label: "Năm xây dựng/bàn giao",
        type: "number",
        required: false,
      },
      {
        key: "notes",
        label: "Ghi chú (các đặc điểm nổi bật)",
        type: "textarea",
        required: false,
        placeholder: "Ví dụ: nhà mới sửa, nội thất nhập khẩu, căn góc...",
      },
    ],
  },

  [PROPERTY_TYPES.LOW_RISE_PROJECT]: {
    dropdownFields: [
      {
        key: "houseType",
        label: "Loại nhà",
        options: LOW_RISE_PROJECT_OPTIONS.types,
        required: true,
      },
      {
        key: "legalStatus",
        label: "Tình trạng pháp lý",
        options: LOW_RISE_PROJECT_OPTIONS.legalStatus,
        required: true,
      },
      {
        key: "furnitureStatus",
        label: "Tình trạng nội thất",
        options: LOW_RISE_PROJECT_OPTIONS.furnitureStatus,
        required: true,
      },
      {
        key: "saleGoal",
        label: "Mục tiêu check giá bán",
        options: LOW_RISE_PROJECT_OPTIONS.saleGoal,
        required: true,
      },
      {
        key: "doorDirection",
        label: "Hướng cửa",
        options: LOW_RISE_PROJECT_OPTIONS.doorDirection,
        required: true,
      },
      {
        key: "bedrooms",
        label: "Số phòng ngủ",
        options: BEDROOM_OPTIONS,
        required: true,
      },
    ],
    inputFields: [
      { key: "projectName", label: "Tên dự án", type: "text", required: true },
      { key: "address", label: "Địa chỉ", type: "text", required: true },
      { key: "building", label: "Toà/Khu", type: "text", required: false },
      { key: "floor", label: "Tầng/Dãy", type: "text", required: false },
      {
        key: "apartmentCode",
        label: "Mã căn hộ",
        type: "text",
        required: false,
      },
      {
        key: "landLength",
        label: "Chiều dài đất (m)",
        type: "number",
        required: true,
      },
      {
        key: "frontage",
        label: "Mặt tiền (m)",
        type: "number",
        required: true,
      },
      { key: "floors", label: "Số tầng", type: "number", required: true },
      { key: "bathrooms", label: "Số WC", type: "number", required: true },
      {
        key: "landArea",
        label: "Diện tích đất (m2)",
        type: "number",
        required: true,
      },
      {
        key: "constructionArea",
        label: "Diện tích xây dựng (m2)",
        type: "number",
        required: true,
      },
      {
        key: "constructionYear",
        label: "Năm xây dựng/bàn giao",
        type: "number",
        required: false,
      },
      {
        key: "notes",
        label: "Ghi chú (các đặc điểm nổi bật)",
        type: "textarea",
        required: false,
        placeholder: "Ví dụ: nhà",
      },
    ],
  },

  [PROPERTY_TYPES.LAND_PROJECT]: {
    dropdownFields: [
      {
        key: "landType",
        label: "Loại đất",
        options: LAND_PROJECT_OPTIONS.types,
        required: true,
      },
      {
        key: "legalStatus",
        label: "Tình trạng pháp lý",
        options: LAND_PROJECT_OPTIONS.legalStatus,
        required: true,
      },
      {
        key: "saleGoal",
        label: "Mục tiêu check giá bán",
        options: LAND_PROJECT_OPTIONS.saleGoal,
        required: true,
      },
      {
        key: "landDirection",
        label: "Hướng đất",
        options: LAND_PROJECT_OPTIONS.landDirection,
        required: true,
      },
    ],
    inputFields: [
      { key: "projectName", label: "Tên dự án", type: "text", required: true },
      { key: "address", label: "Địa chỉ", type: "text", required: true },
      { key: "building", label: "Toà/Khu", type: "text", required: false },
      { key: "floor", label: "Tầng/Dãy", type: "text", required: false },
      {
        key: "apartmentCode",
        label: "Mã căn hộ",
        type: "text",
        required: false,
      },
      {
        key: "landLength",
        label: "Chiều dài đất (m)",
        type: "number",
        required: true,
      },
      {
        key: "frontage",
        label: "Mặt tiền (m)",
        type: "number",
        required: true,
      },
      {
        key: "landArea",
        label: "Diện tích đất (m2)",
        type: "number",
        required: true,
      },
      {
        key: "constructionYear",
        label: "Năm xây dựng/bàn giao",
        type: "number",
        required: false,
      },
      {
        key: "notes",
        label: "Ghi chú (các đặc điểm nổi bật)",
        type: "textarea",
        required: false,
        placeholder: "Ví dụ: nhà",
      },
    ],
  },

  [PROPERTY_TYPES.PRIVATE_HOUSE]: {
    dropdownFields: [
      {
        key: "houseType",
        label: "Loại nhà",
        options: PRIVATE_HOUSE_OPTIONS.types,
        required: true,
      },
      {
        key: "legalStatus",
        label: "Tình trạng pháp lý",
        options: PRIVATE_HOUSE_OPTIONS.legalStatus,
        required: true,
      },
      {
        key: "furnitureStatus",
        label: "Tình trạng nội thất",
        options: PRIVATE_HOUSE_OPTIONS.furnitureStatus,
        required: true,
      },
      {
        key: "saleGoal",
        label: "Mục tiêu check giá bán",
        options: PRIVATE_HOUSE_OPTIONS.saleGoal,
        required: true,
      },
      {
        key: "doorDirection",
        label: "Hướng cửa",
        options: PRIVATE_HOUSE_OPTIONS.doorDirection,
        required: true,
      },
      {
        key: "bedrooms",
        label: "Số phòng ngủ",
        options: BEDROOM_OPTIONS,
        required: true,
      },
    ],
    inputFields: [
      {
        key: "address",
        label:
          "Địa chỉ (Ghi rõ: Số nhà, ngõ/hẻm, đường/phố, quận/huyện, tỉnh/thành phố)",
        type: "textarea",
        required: true,
      },
      {
        key: "landLength",
        label: "Chiều dài mảnh đất (m)",
        type: "number",
        required: true,
      },
      {
        key: "frontage",
        label: "Mặt tiền (m)",
        type: "number",
        required: true,
      },
      { key: "floors", label: "Số tầng", type: "number", required: true },
      { key: "bathrooms", label: "Số WC", type: "number", required: true },
      {
        key: "landArea",
        label: "Diện tích đất (m2)",
        type: "number",
        required: true,
      },
      {
        key: "constructionArea",
        label: "Diện tích xây dựng (m2)",
        type: "number",
        required: true,
      },
      {
        key: "constructionYear",
        label: "Năm xây dựng/bàn giao",
        type: "number",
        required: false,
      },
      {
        key: "notes",
        label: "Ghi chú (các đặc điểm nổi bật)",
        type: "textarea",
        required: false,
        placeholder: "Ví dụ: nhà mới sửa, nội thất nhập khẩu, căn góc...",
      },
    ],
  },

  [PROPERTY_TYPES.OTHER_PROPERTY]: {
    dropdownFields: [
      {
        key: "propertyTypeOther",
        label: "Loại BĐS",
        options: OTHER_PROPERTY_OPTIONS.types,
        required: true,
      },
      {
        key: "legalStatus",
        label: "Tình trạng pháp lý",
        options: OTHER_PROPERTY_OPTIONS.legalStatus,
        required: true,
      },
      {
        key: "furnitureStatus",
        label: "Tình trạng nội thất",
        options: OTHER_PROPERTY_OPTIONS.furnitureStatus,
        required: false,
        conditional: (formData) =>
          formData.propertyTypeOther && formData.propertyTypeOther !== "Lô đất",
      },
      {
        key: "saleGoal",
        label: "Mục tiêu check giá bán",
        options: OTHER_PROPERTY_OPTIONS.saleGoal,
        required: true,
      },
      {
        key: "direction",
        label: "Hướng cửa/đất",
        options: OTHER_PROPERTY_OPTIONS.direction,
        required: true,
      },
    ],
    inputFields: [
      {
        key: "address",
        label:
          "Địa chỉ (Ghi rõ: Số nhà, ngõ/hẻm, đường/phố, quận/huyện, tỉnh/thành phố)",
        type: "textarea",
        required: true,
      },
      {
        key: "landLength",
        label: "Chiều dài mảnh đất (m)",
        type: "number",
        required: true,
      },
      {
        key: "frontage",
        label: "Mặt tiền (m)",
        type: "number",
        required: true,
      },
      {
        key: "landArea",
        label: "Diện tích đất (m2)",
        type: "number",
        required: true,
      },
      {
        key: "constructionArea",
        label: "Diện tích xây dựng (m2)",
        type: "number",
        required: false,
      },
      {
        key: "constructionYear",
        label: "Năm xây dựng/bàn giao",
        type: "number",
        required: false,
      },
      {
        key: "notes",
        label: "Ghi chú (các đặc điểm nổi bật)",
        type: "textarea",
        required: false,
        placeholder: "Ví dụ: nhà mới sửa, nội thất nhập khẩu, căn góc...",
      },
    ],
  },
};

// Default form data structure
export const getDefaultFormData = () => ({
  propertyType: "",

  // Dropdown values
  apartmentType: "",
  houseType: "",
  landType: "",
  propertyTypeOther: "",
  legalStatus: "",
  furnitureStatus: "",
  saleGoal: "",
  balconyDirection: "",
  doorDirection: "",
  landDirection: "",
  direction: "",

  // Input values
  projectName: "",
  address: "",
  building: "",
  floor: "",
  apartmentCode: "",
  bedrooms: "",
  bathrooms: "",
  area: "",
  landLength: "",
  frontage: "",
  floors: "",
  landArea: "",
  constructionArea: "",
  constructionYear: "",
  notes: "",
});
